import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_112: FaireProductEntity = {
  token: "catalog_prod_prod-112",
  type: "product",
  name: "Santa Coin Purses with Display Stand (PK/12 Ast)",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 28.27,
  msrpDollars: 70.68,
  sku: "VI0112",
  caseSize: 12,
  material: "Glass",
  collectionToken: "col_vintage-holiday",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 102,
  description: "Beautiful Vintage Holiday piece perfect for any home.",
  categoryTokens: ["catalog_cat_storage-organization"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
